module.exports = __webpack_public_path__ + "img/goods11-1.bf028ba7.jpg";